import type {QueryEntrySection} from 'common/query-builder/query-entry-section';

import {Entry, SelectorType, SelectorTypeDefinitions} from '../types';
// eslint-disable-next-line import/no-cycle
import {getEntryRowHelpers} from './index';
import {RowType} from './types';

/**
 * Generates an empty entry for a given selector type
 */
export function getNewEmptyEntry({type, section}: {type: SelectorType; section: QueryEntrySection}): Entry {
  const rowType = type as RowType;

  if (rowType === SelectorTypeDefinitions.PropertyExpansion) {
    return {
      type: SelectorTypeDefinitions.PropertyExpansion as any,
      event: null,
      filters: [],
    };
  }

  return getEntryRowHelpers(rowType)?.getNewEntry?.(section, rowType);
}
